/* eslint-disable indent */
import React, { Component } from 'react';
import * as yup from 'yup';
import Cookies from 'js-cookie';
import { Layout } from '../../../Common/Component';
import ForgotPassword from './ForgotPassword';

import eye from '../../../../Assets/images/eye.svg';
import eyeoff from '../../../../Assets/images/eye-off.svg';


class Login extends Component {

    state = {
        email: '',
        password: '',
        passwordIsVisible: false,
        LoginErrors: '',
        resetPassEmail: '',
        is_forgot_pwd: false,
        rememberUser: false,
        validPassword: {
            containsUppercase: false,
            containsNumber: false,
            checkLength: false,
        },
        is_btn_active: false
    }

    componentDidMount = () => {
        let user = JSON.parse(localStorage.getItem('userKey'))
        if (user?.user?.user?.uuid) {
            window.location.assign('/account');
        }

        const Secure = Cookies.get('Secure-SSID_ROLE')
            ? JSON.parse(Cookies.get('Secure-SSID_ROLE'))
            : "";

        if (Secure) {
            this.setState({
                rememberUser: Secure.rememberUser,
                email: Secure.email,
                password: Secure.password,
                is_btn_active: true
            })
        }
    }

    UNSAFE_componentWillReceiveProps = (props) => {
        if (Object.keys(props.Login.data).length > 0 && props.Login.data !== this.props.Login.data) {
            //
            window.location.assign('/account')
        }
        if (Object.keys(props.Login.errors).length > 0 && props.Login.errors !== this.props.Login.errors) {
            // display error messsage
            this.setState({
                loader: false,
                LoginErrors: props.Login.errors.non_field_errors && props.Login.errors.non_field_errors
            })
            Cookies.remove('Secure-SSID_ROLE', { path: '' });
            this.setState({
                rememberUser: false,
            })
        }
    }


    // Validate Form
    validateUser = (validPassword) => {
        var self = this;

        setTimeout(() => {
            let { email, password } = self.state;
            const UserSchema = yup.object().shape({
                email: yup.string().required("Email is required").email('Your Email is invalid.'),
                password: yup.string().required("Password is required"),
                validPassword: yup.object().shape({
                    containsUppercase: yup.bool().oneOf([true], ''),
                    containsNumber: yup.bool().oneOf([true], ''),
                    is_password_match: yup.bool().oneOf([true], ''),
                })
            })

            const UserData = {
                email, password,
                validPassword
            }
            // check validity
            let IsValid;

            UserSchema.isValid(UserData)
                .then(function (valid) {
                    IsValid = valid
                });

            setTimeout(() => {
                if (IsValid) {
                    self.setState({
                        is_btn_active: true
                    })
                }
                else {
                    UserSchema.validate(UserData, { abortEarly: false })
                        .catch(function () {
                            self.setState({
                                is_btn_active: false
                            })
                        });
                }
            }, 100);
        }, 500);
    }


    // set value
    userOnChange = (e) => {
        let { validPassword } = this.state;

        if (e.target.name === 'password') {
            validPassword = Object.assign(validPassword, {
                'containsUppercase': (/[A-Z]/).test(e.target.value),
                'containsNumber': (/\d/).test(e.target.value),
                'checkLength': e.target.value.length >= 8,
            });
        }
        this.setState({ [e.target.name]: e.target.value, validPassword }, () => { this.validateUser(this.state.validPassword) });
    }

    //Show Hide Password
    toggleEye = () => {
        this.setState(prevstate => ({ passwordIsVisible: !prevstate.passwordIsVisible }));
    }

    //remember user
    toggleRememberUser = (e) => {

        if (e.target.checked) {
            this.setState({
                rememberUser: true
            })
        }
        else {
            this.setState({
                rememberUser: false
            })
            Cookies.remove('Secure-SSID_ROLE', { path: '' });
        }


    }

    //call login API
    loginUSer = (e) => {
        e.preventDefault();
        let { email, password, rememberUser } = this.state;
        this.setState({ loader: true })
        let is_crm = false;
        this.props.loginUser({ email, password, is_crm });

        if (rememberUser) {
            Cookies.set('Secure-SSID_ROLE', JSON.stringify({ 'rememberUser': rememberUser, "email": email, "password": password }));
        }
        else {
            Cookies.remove('Secure-SSID_ROLE', { path: '' });
        }
    }

    toggleView = () => {
        this.setState({ is_forgot_pwd: !this.state.is_forgot_pwd, email: '', password: '' })
    }

    render() {
        let { email, password, passwordIsVisible, rememberUser, loader, LoginErrors, is_forgot_pwd, is_btn_active } = this.state;
        return (
            <Layout>
                <div className="page_inner_content">
                    <div className="truck-image-wrapper">
                        <img className="truck-image no-mobile" src={'https://doody-fe-bucket.s3.amazonaws.com/truck.png'} alt='truck' />
                        <img className="mobile-nav" src={'https://doody-fe-bucket.s3.amazonaws.com/truck-responsive.png'} alt='truck' />
                    </div>
                    <div className="container">
                        <div className="login-container">
                            <div className="row">
                                <div className="col-md-2" />
                                <div className="col-sm-12 col-md-4" >
                                    <div className="top-padding">

                                        {/* Login HTML */}

                                        {is_forgot_pwd ?
                                            <div>
                                                < ForgotPassword
                                                    ForgotPwd={this.props.ForgotPwd}
                                                    forgotPassword={this.props.forgotPassword}
                                                    toggleView={this.toggleView}
                                                />
                                            </div> :
                                            <form onSubmit={(e) => { this.loginUSer(e) }}>
                                                <div className="text-one">Welcome to the DoodyCalls Customer Portal</div>
                                                <div className="text-two">Sign in for the scoop on your service!</div>
                                                <div className="err_msg">{LoginErrors}</div>
                                                <input
                                                    type='email'
                                                    aria-label='email'
                                                    name='email'
                                                    id='email'
                                                    value={email}
                                                    autoComplete="new-email"
                                                    className='form--control'
                                                    placeholder='Email Address'
                                                    onChange={(e) => { this.userOnChange(e) }}

                                                />
                                                <div className="input-text">
                                                    <input
                                                        type={passwordIsVisible ? 'text' : 'password'}
                                                        placeholder='Password'
                                                        name='password'
                                                        className='form--control'
                                                        aria-label="password"
                                                        id='password'
                                                        autoComplete="new-password"

                                                        value={password}
                                                        onChange={(e) => { this.userOnChange(e) }}
                                                    />
                                                    <span className="eye-icon">
                                                        {passwordIsVisible
                                                            ? <img src={eyeoff} alt="" onClick={() => this.toggleEye()} />
                                                            : <img src={eye} alt="" onClick={() => this.toggleEye()} />}
                                                    </span>
                                                </div>
                                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', height: 40, alignItems: 'center' }}>
                                                    <div className="checkbox_wrapper">
                                                        <input id="rememberUser"
                                                            type="checkbox"
                                                            className="mb-0"
                                                            checked={rememberUser}
                                                            onChange={(e) => this.toggleRememberUser(e)}
                                                        />
                                                        <label htmlFor="rememberUser">Remember me</label>
                                                    </div>
                                                    <div className="link" onClick={() => {
                                                        this.setState({
                                                            is_forgot_pwd: true
                                                        })
                                                    }}>Forgot Password?</div>
                                                </div>
                                                <div className='submit_btn'>
                                                    <button
                                                        aria-label='submit-button'
                                                        type='submit'
                                                        disabled={!is_btn_active}
                                                        // onClick={() => { this.loginUSer() }}
                                                        className='btn btn btn--secondary'>
                                                        Login</button>
                                                </div>
                                            </form>
                                        }
                                        
                                        <span style={{fontWeight: "bold"}}>
                                            Google Chrome is the recommended browser of DoodyCalls.
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        loader ?
                            <div className='loader_wrapper'>
                                <div className='loader07'></div>
                            </div>
                            : ''
                    }
                </div>
            </Layout>
        );
    }
}

export default Login;